/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
document.addEventListener('DOMContentLoaded', function () {
	const tocLinks = document.querySelectorAll('a[data-smooth-scroll="true"]');

	tocLinks.forEach(link => {
		link.addEventListener('click', function (event) {
			event.preventDefault();
			const targetId = this.getAttribute('href').substring(1);
			const targetElement = document.getElementById(targetId);

			if (targetElement) {
				// Smoothly scroll to the target element
				targetElement.scrollIntoView({ behavior: 'smooth' });

				// Use IntersectionObserver to set focus once the element is in view
				const observer = new IntersectionObserver((entries, observer) => {
					entries.forEach(entry => {
						if (entry.isIntersecting) {
							targetElement.setAttribute('tabindex', '-1');
							targetElement.focus();

							// Optionally, remove the tabindex after focus to prevent tab stops
							targetElement.addEventListener('blur', () => {
								targetElement.removeAttribute('tabindex');
							}, { once: true });

							// Stop observing once the focus is set
							observer.disconnect();
						}
					});
				}, { threshold: 1.0 });

				observer.observe(targetElement);
			}
		});
	});
});

/* eslint-enable no-console */
